import _ from 'lodash';

import { SIGNER_NAMES_BY_VALUE, TAG_NAMES_BY_VALUE } from '../../PrismFormEditor.pickers.constants';

export const buildSignatureLabel = ({ dataHellosignTag, dataHellosignSigner }) => {
  const tagName = _.isString(dataHellosignTag) ? TAG_NAMES_BY_VALUE.get(dataHellosignTag) : null;
  const signerName = _.isString(dataHellosignSigner)
    ? SIGNER_NAMES_BY_VALUE.get(dataHellosignSigner)
    : null;

  if (tagName && signerName) {
    return `${tagName} (${signerName})`;
  }

  if (tagName) {
    return tagName;
  }

  if (signerName) {
    return signerName;
  }

  return '';
};
